'use client';
import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { workerTypeData } from '@/lib/mockData';

const CustomTooltip = ({ active, payload }: any) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-card border border-border rounded-lg shadow-lg p-3 text-sm">
      <p className="font-600 text-foreground">{payload[0].name}</p>
      <p className="text-muted-foreground">{payload[0].value} workers</p>
    </div>
  );
};

export default function WorkerTypeChart() {
  const total = workerTypeData.reduce((s, d) => s + d.value, 0);
  return (
    <div className="bg-card border border-border rounded-xl p-5 h-full">
      <div className="mb-4">
        <h2 className="text-base font-600 text-foreground">Workers by Type</h2>
        <p className="text-xs text-muted-foreground mt-0.5">{total} total registered workers</p>
      </div>
      <ResponsiveContainer width="100%" height={180}>
        <PieChart>
          <Pie data={workerTypeData} cx="50%" cy="50%" innerRadius={50} outerRadius={75} paddingAngle={3} dataKey="value">
            {workerTypeData.map((entry) => (
              <Cell key={`cell-${entry.name}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
        </PieChart>
      </ResponsiveContainer>
      <div className="space-y-2 mt-2">
        {workerTypeData.map((d) => (
          <div key={`legend-${d.name}`} className="flex items-center justify-between text-sm">
            <div className="flex items-center gap-2">
              <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ backgroundColor: d.color }} />
              <span className="text-muted-foreground">{d.name}</span>
            </div>
            <span className="font-600 text-foreground tabular-nums">{d.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}